import React, { ChangeEventHandler, forwardRef, useCallback } from 'react';
import { useIntl } from 'react-intl';

import { ReservationFlowQuestionnaireFieldItem } from 'src/interfaces/reservation_flow';
import { useDataAttributeProps } from 'src/hooks/useDataAttributeProps';
import { RSTextArea } from 'src/reservation-page/forms/RSTextArea';

export interface QuestionnaireInputTextAreaProps {
  [key: `data-${string}`]: string | undefined;
  value?: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  item: ReservationFlowQuestionnaireFieldItem;
  isError?: boolean;
}

export const QuestionnaireInputTextArea = forwardRef<
  HTMLTextAreaElement,
  QuestionnaireInputTextAreaProps
>((props, ref) => {
  const dataAttributes = useDataAttributeProps(props);
  const { value, onChange, onBlur, item, isError } = props;

  const intl = useIntl();

  const onInputChange = useCallback<ChangeEventHandler<HTMLTextAreaElement>>(
    (event) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  return (
    <div>
      <div className="mb-1.5">
        <div className="rs-font text-16 text-gray-1000 pc:text-15 whitespace-pre-wrap font-normal">
          {item.label}
        </div>
      </div>
      <RSTextArea
        {...dataAttributes}
        ref={ref}
        labelText={intl.formatMessage({
          defaultMessage: '回答内容',
          id: 'gg+Bti',
          description:
            'src/templates/merchants/resources/book/components/questionnaire/QuestionnaireInputTextArea/index.tsx',
        })}
        isBlock
        isError={isError}
        required={item.is_required}
        value={typeof value !== 'undefined' ? value : ''}
        onChange={onInputChange}
        onBlur={onBlur}
      />
    </div>
  );
});

QuestionnaireInputTextArea.displayName = 'QuestionnaireInputTextArea';
